
const tech = [
    {
        name: "html",
        image: "html.png"
    },
    {
        name:"css",
        image:"css.png",
    },
    {
        name:"react",
        image:"react.png",
    },
    {
        name:"js",
        image:"js.png",
    },
    {
      name:"java",
      image:"java.png"
    },
    {
        name:"express",
        image:"express.png",
    },
    {
        name:"c++",
        image:"c++.png",
    },
    {
        name:"python",
        image:"python.png",
    },
    {
        name:"jquery",
        image:"jquery.png",
    },
    {
        name:"bootstrap",
        image:"bootstrap.png",
    },
    {
        name:"chakraUI",
        image:"chakra-ui.png",
    },
    {
        name:"postman",
        image:"postman.png",
    },
    {
        name:"node",
        image:"node.png",
    },
    {
        name:"mongoDB",
        image:"mongodb.png",
    },
    {
        name: "PostgreSQL",
        image: "postgres.png"
    },
    {
        name:"firebase",
        image:"firebase.png",
    },
    {
        name:"github",
        image:"github.png",
    },
    {
        name:"figma",
        image:"figma.png",
    },
    {
        name:"api",
        image:"api.png",
    },
    {
        name:"docker",
        image:"docker.png",
    },
    {
        name:"kubernetes",
        image:"kubernetes.png",
    },
    
]

export default tech;
